'use client';

import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { SliderArrow } from '@trwl/shared/ui/icons';
import cn from 'classnames';
import { FC, ReactElement, useRef } from 'react';
import SwiperCore from 'swiper';
import { A11y, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

export interface ProductSliderProps {
  products: ReactElement[];
  title: string;
}

export const ProductSlider: FC<ProductSliderProps> = ({ products, title }) => {
  const swiperRef = useRef<SwiperCore>(null);

  return (
    <section className="w-full" aria-label={title} tabIndex={-1} role="region">
      <h2 className="text-[#282828] text-2xl mb-4">{title}</h2>
      <div className="w-full relative md:px-[40px]">
        <button
          type="button"
          aria-label="Показать предыдущие товары"
          onClick={() => swiperRef.current?.slidePrev()}
          className={cn(
            'absolute top-0 left-0 w-[40px] h-full',
            'hidden md:flex items-center justify-center',
            'hover:bg-[#f5f5f5] rounded-[6px] duration-300',
          )}
        >
          <SliderArrow className="rotate-[180deg] pointer-events-none" />
        </button>
        <Swiper
          modules={[A11y, Navigation]}
          className="w-full"
          wrapperClass="w-full"
          breakpoints={{
            0: {
              slidesPerView: 1.65,
            },
            800: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 4,
            },
            1280: {
              slidesPerView: 5,
            },
          }}
          onBeforeInit={(swiper) => {
            swiperRef.current = swiper;
          }}
          tag="ul"
          aria-label={`${title} — список товаров`}
        >
          {products.map((product, key) => (
            <SwiperSlide tag="li" key={key} role="listitem">
              <div className={'mx-[10px]'}>{product}</div>
            </SwiperSlide>
          ))}
        </Swiper>
        <button
          type="button"
          aria-label="Показать следующие товары"
          onClick={() => swiperRef.current?.slideNext()}
          className={cn(
            'absolute top-0 right-0 w-[40px] h-full',
            'hidden md:flex items-center justify-center',
            'hover:bg-[#f5f5f5] rounded-[6px] duration-300',
          )}
        >
          <SliderArrow className="pointer-events-none" />
        </button>
      </div>
    </section>
  );
};
